import React from 'react';
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import InnerBanner from '../components/PagesComponents/InnerBanner';
import AdminTestimonialDetailInfo from '../components/AdminComponents/AdminTestimonialDetailInfo';
const AdminTestimonialDetail = () => {
 return (
    <>
<InnerBanner pageKey="adminTestimonialDetail" />

      <section className='dashboard'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12'>
                   <AdminTestimonialDetailInfo/> 
                </div>
            </div>
        </div>
      </section>
    </>
 );

};

export default AdminTestimonialDetail;